import { setShowRetentionPaymentModal } from '../State/showRetentionPaymentModal'
import { setSelectedRetentionPaymentId } from '../State/selectedRetentionPaymentId'

export default () => async (dispatch) => {

  dispatch(setSelectedRetentionPaymentId(null))
  dispatch(setShowRetentionPaymentModal(false))

}